import { create, el } from "@dhx/ts-common/dom";
import { getLabelStyle } from "@dhx/ts-common/html";
import { View } from "@dhx/ts-common/view";
import { Popup } from "@dhx/ts-popup";
import { ILabel } from "../../types";

export class Label extends View {
	public config: ILabel;
	protected _handlers: any;
	protected _helper: Popup;
	constructor(container: HTMLElement | string, config = {}) {
		super(container, config);
		this._handlers = {
			showHelper: e => {
				e.preventDefault();
				e.stopPropagation();
				this._helper.show(e.target, {
					mode: this.config.labelPosition === "left" ? "bottom" : "right",
				});
			},
			hideHelper: e => {
				e.preventDefault();
				e.stopPropagation();
				this._helper.hide();
			},
			...this._getHandlers(),
		};
		const render = () => this._draw();
		this.mount(container, create({ render }));
	}
	protected _destructor() {
		this._helper && this._helper.destructor();
		this.config = this._handlers = this._helper = null;
		this.unmount();
	}
	protected _getHandlers() {
		return {};
	}
	protected _init() {
		return;
	}
	protected _draw() {
		return this._drawLabel();
	}
	protected _drawLabel() {
		const { id, helpMessage, required } = this.config;
		if (this.config.helpMessage) {
			if (this._helper) {
				this._helper.attachHTML(this.config.helpMessage);
			} else {
				this._helper = new Popup({
					css: "dhx_tooltip dhx_tooltip--forced dhx_tooltip--light",
				});
				this._helper.attachHTML(this.config.helpMessage);
			}
		}
		const labelStyle = getLabelStyle(this.config);
		return (
			labelStyle &&
			el(
				`${this.config.type.includes("group") ? "legend" : "label"}.dhx_label`,
				{
					for: id || this._uid,
					class: helpMessage ? "dhx_label--with-help" : "",
					style: labelStyle.style,
				},
				helpMessage
					? [
							(labelStyle.label || required) && el("span.dhx_label__holder", labelStyle.label),
							el("span.dhx_label-help.dxi.dxi-help-circle-outline", {
								tabindex: "0",
								role: "button",
								onclick: this._handlers.showHelper,
								onfocus: this._handlers.showHelper,
								onblur: this._handlers.hideHelper,
								id: `dhx_label__help_${id || this._uid}`,
							}),
					  ]
					: labelStyle.label
			)
		);
	}
}
